import { OnDragEndResponder } from 'react-beautiful-dnd'

interface ICreateDndHandlerProps {
  ids: string[]
  changeOrder: (ids: string[]) => void
}

const createDndHandler = ({ ids, changeOrder }: ICreateDndHandlerProps) => {
  const handleDragEnd: OnDragEndResponder = ({ draggableId, source, destination }) => {
    if (!destination) return

    // If we are in the same position and in the same "droppable" area, then skip.
    if (destination.droppableId === source.droppableId && destination.index === source.index) return

    const movedItem = ids.find((id) => id === draggableId)
    if (!movedItem) return

    const data = ids.filter((id) => id !== draggableId)
    data.splice(destination.index, 0, movedItem)

    changeOrder(data)
  }

  return { handleDragEnd }
}

export { createDndHandler }
